import {
    addCarProRequest,
    addCarRequest,
    deleteCarRequest,
    editCarProRequest,
    editCarRequest,
    getCarListRequest,
    getCarRequest,
    updateCarRequest,
} from '../../../services/network/sell/car';

class CommonCarService {
    async addCar(values) {
        return await addCarRequest(values);
    }

    async addCarPro(values) {
        return await addCarProRequest(values);
    }

    async getCar(id) {
        return await getCarRequest(id);
    }

    async getCarList(payload) {
        return await getCarListRequest(payload);
    }

    async deleteCar(id) {
        return await deleteCarRequest(id);
    }

    async editCar(updates) {
        return await editCarRequest(updates);
    }

    async editCarPro(updates) {
        return await editCarProRequest(updates);
    }

    async updateCar(updates) {
        return await updateCarRequest(updates);
    }
}

export const CarService = new CommonCarService();
